<template>
  <v-form ref="form" v-on:submit.prevent="submit" v-model="valid">
    <v-card elevation="0">
      <v-card-text>
        <v-container grid-list-xl fluid>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <date-picker
                :date.sync="params.start"
                @change="fieldErrors.start = []"
                :error-messages="fieldErrors.start"
                label="Desde"/>
            </v-flex>
            <v-flex xs12 sm6>
              <date-picker
                :date.sync="params.end"
                @change="fieldErrors.end = []"
                :error-messages="fieldErrors.end"
                label="Hasta"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn
          large
          depressed
          color="accent"
          type="submit"
          :loading="loading"
          >
            Generar informe
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import api from '@/api/app'
import formMixin from '@/mixins/formMixin'

export default {
  mixins: [formMixin],
  data () {
    return {
      tab: null,
      params: {},
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null
    }
  },
  methods: {
    onSubmit () {
      return api.report('pesadas', this.params)
    },
    onSuccess (response) {
      window.location.href = response['download_url']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/partials/MeasurementsReport.vue